const commonVariables = {
  color: {
    primary: '#f47521',
    success: '#33b201',
    default: '#000000',
    alert: '#ff0000',
    background: '#eeefe9',
    posBackground: '#c8e4f0',
    moduleBackground: '#ffffff',
    gray: '#cbcbcb'
  },
  vendingColor: {
    available: '#d4d4d4',
    itemForSale: '#fdb797',
    itemSold: '#468ac9',
    preOrderItemNotYetStock: '#fff',
    preOrderItemStocked: '#fdd67f',
    preOrderItemCollected: '#74b969',
    preOrderItemExpired: '#dc584a'
  }
};

export default commonVariables;
